var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"savingAlert"}},[_c('b-alert',{attrs:{"show":_vm.successfulAlertCounter,"dismissible":"","variant":"success","fade":""},on:{"dismissed":function($event){_vm.successfulAlertCounter=0}}},[_vm._v(" "+_vm._s(_vm.$t('settings.save_success'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }